export default class TID300Measurement {
    constructor() {}
}
